import { render } from "./accountBilling.vue?vue&type=template&id=95f05fc0"
import script from "./accountBilling.vue?vue&type=script&lang=js"
export * from "./accountBilling.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__